/* Brassyra v2.1 — mobile gallery rail, reveal failsafe, sticky-bar spacing.
   v2.7 — expandable product gallery (lightbox). */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 900px)');

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initGallery() {
    var g = document.querySelector('.bz-gallery');
    if (!g || g.__bz2) return;
    g.__bz2 = true;
    var count = document.createElement('div');
    count.className = 'bz-gcount';
    g.parentNode.insertBefore(count, g.nextSibling);

    function slides() {
      return Array.prototype.filter.call(g.querySelectorAll('figure'), function (f) { return f.offsetParent !== null; });
    }
    function update() {
      var list = slides();
      if (!mq.matches || list.length < 2) { count.style.display = 'none'; return; }
      count.style.display = '';
      var mid = g.scrollLeft + g.clientWidth / 2, i = 0, best = Infinity;
      list.forEach(function (f, k) {
        var c = f.offsetLeft + f.offsetWidth / 2, d = Math.abs(c - mid);
        if (d < best) { best = d; i = k; }
      });
      count.innerHTML = '<b>' + pad(i + 1) + '</b> / ' + pad(list.length);
    }
    var tick;
    g.addEventListener('scroll', function () {
      if (tick) return;
      tick = requestAnimationFrame(function () { tick = null; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    if (mq.addEventListener) mq.addEventListener('change', update);
    update();
  }

  /* The gallery thumbs are served at layout width; for the expanded view take the
     largest candidate the srcset offers rather than whatever the browser picked. */
  function largestSrc(im) {
    var ss = im.getAttribute('srcset');
    if (!ss) return im.currentSrc || im.src;
    var best = null, bw = -1;
    ss.split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      if (!bits[0]) return;
      var w = parseInt((bits[1] || '').replace(/[^0-9]/g, ''), 10) || 0;
      if (w >= bw) { bw = w; best = bits[0]; }
    });
    return best || im.currentSrc || im.src;
  }

  /* Expandable product gallery. Deliberately does NOT touch the gallery DOM:
     on mobile the figures are scroll-snap items and .pair is display:contents,
     so wrapping them in buttons would break the swipe rail and the counter. */
  function initZoom() {
    var g = document.querySelector('.bz-gallery');
    if (!g || g.__bzZoom) return;
    var imgs = Array.prototype.slice.call(g.querySelectorAll('figure img'));
    if (!imgs.length) return;
    g.__bzZoom = true;

    imgs.forEach(function (im, n) {
      im.setAttribute('role', 'button');
      im.setAttribute('tabindex', '0');
      im.setAttribute('aria-label', 'Expand image ' + (n + 1) + ' of ' + imgs.length);
    });
    g.classList.add('bz-gallery--zoom');

    var old = document.getElementById('bz-lb');
    if (old && old.parentNode) old.parentNode.removeChild(old);

    var lb = document.createElement('div');
    lb.id = 'bz-lb';
    lb.className = 'bz-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product image');
    lb.innerHTML =
      '<button type="button" class="bz-lb-x" aria-label="Close">×</button>' +
      '<button type="button" class="bz-lb-a bz-lb-p" aria-label="Previous image">‹</button>' +
      '<button type="button" class="bz-lb-a bz-lb-n" aria-label="Next image">›</button>' +
      '<figure class="bz-lb-f"><img alt=""><figcaption></figcaption></figure>';
    document.body.appendChild(lb);

    var big = lb.querySelector('img');
    var cap = lb.querySelector('figcaption');
    var bx = lb.querySelector('.bz-lb-x');
    var bp = lb.querySelector('.bz-lb-p');
    var bn = lb.querySelector('.bz-lb-n');
    var i = 0, last = null, t = null;

    if (imgs.length < 2) { bp.hidden = true; bn.hidden = true; }

    function show(n) {
      i = (n + imgs.length) % imgs.length;
      big.src = largestSrc(imgs[i]);
      big.alt = imgs[i].alt || '';
      cap.textContent = (i + 1) + ' / ' + imgs.length;
    }
    function open(n) {
      last = document.activeElement;
      show(n);
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (t) clearTimeout(t);
      t = setTimeout(function () { lb.classList.add('is-on'); }, 10);
      bx.focus();
    }
    function close() {
      lb.classList.remove('is-on');
      if (t) clearTimeout(t);
      t = setTimeout(function () { lb.hidden = true; big.removeAttribute('src'); }, 200);
      document.documentElement.style.overflow = '';
      if (last && last.focus) last.focus();
    }

    /* A swipe along the mobile rail must not register as a tap. */
    var sx = 0, sy = 0, ssl = 0, dragged = false;
    g.addEventListener('pointerdown', function (e) {
      sx = e.clientX; sy = e.clientY; ssl = g.scrollLeft; dragged = false;
    }, { passive: true });
    g.addEventListener('pointerup', function (e) {
      dragged = Math.abs(e.clientX - sx) > 8 || Math.abs(e.clientY - sy) > 8 || Math.abs(g.scrollLeft - ssl) > 4;
    }, { passive: true });

    imgs.forEach(function (im, n) {
      im.addEventListener('click', function () { if (!dragged) open(n); });
      im.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(n); }
      });
    });

    bx.addEventListener('click', close);
    bp.addEventListener('click', function () { show(i - 1); });
    bn.addEventListener('click', function () { show(i + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target === big.parentNode) close(); });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(i + 1);
      else if (e.key === 'ArrowLeft') show(i - 1);
      else if (e.key === 'Tab') {
        var f = [bx, bp, bn].filter(function (b) { return !b.hidden; });
        var k = f.indexOf(document.activeElement);
        e.preventDefault();
        f[(k + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    });

    var tx = null;
    lb.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (tx === null) return;
      var d = e.changedTouches[0].clientX - tx; tx = null;
      if (Math.abs(d) > 45) show(d < 0 ? i + 1 : i - 1);
    }, { passive: true });
  }

  /* If the reveal observer never fires (bfcache, older mobile browsers), nothing must stay invisible. */
  function revealFailsafe() {
    setTimeout(function () {
      document.querySelectorAll('.bz-rv.pre').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 1.2) el.classList.remove('pre');
      });
    }, 2200);
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) document.querySelectorAll('.bz-rv.pre').forEach(function (el) { el.classList.remove('pre'); });
  });

  function initBarSpacing() {
    var bar = document.querySelector('[data-bz-stickybar]');
    if (!bar || bar.__bz2) return;
    bar.__bz2 = true;
    var sync = function () { document.body.classList.toggle('bz-bar-on', bar.classList.contains('show') && mq.matches); };
    new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', sync);
    sync();
  }

  function initCompareHint() {
    var c = document.querySelector('.bz-compare');
    if (!c || c.__bz2) return;
    c.__bz2 = true;
    if (c.scrollWidth <= c.clientWidth + 8) return;
    var h = document.createElement('div');
    h.className = 'bz-hint';
    h.textContent = 'Swipe the table sideways →';
    c.parentNode.insertBefore(h, c.nextSibling);
    c.addEventListener('scroll', function () { h.style.opacity = c.scrollLeft > 12 ? '0' : '1'; }, { passive: true });
    h.style.transition = 'opacity .3s';
  }

  function boot() { initGallery(); initZoom(); initBarSpacing(); initCompareHint(); revealFailsafe(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
